import { Box, Text, HStack, Flex, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'
import Link from 'next/link'
import BenefitMobile from './benefit-mobie'

const ProductCard06 = () => {
  const productData = {
    titleJP: '自持脑部健康，提升认知和记忆力',
    titleEN:
      'Support brain health, boost cognitive function & enhance mental clarity',
    subTitle: '改善脑弱态 / Improve cognitive weakness',
    descJP: `活脑素是一种经过科学验证的脑部健康补充剂，包含三种强效成分，旨在提升认知功能、改善记忆力和增强注意力。这一配方旨在强化大脑并支持整体心理表现`,
    descEN:
      'Brain & Memory Vitalizer is a scientifically validated brain health supplement that features three powerful ingredients designed to boost cognitive function, enhance memory, and improve concentration. This formulation aims to strengthen the brain and support overall mental performance.',
    imageUrl:
      'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item-6-1734075592410.png'
  }

  const benefitData = [
    {
      ratio: 636 / 674,
      imageUrl:
        'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/be-update-1731662053288.png'
    }
  ]

  return (
    <Flex
      flexDir={{
        base: 'column-reverse',
        lg: 'row'
      }}
      justifyContent="space-between"
      pt={{
        base: '20px',
        lg: '105px'
      }}
      pb="80px"
      gap={5}
      id="brain-memory"
    >
      <Box
        w={{
          base: '100%',
          lg: '60%'
        }}
      >
        {/* Title and Subtitle */}
        <Box
          w="100%"
          maxW={{
            base: '100%',
            lg: '650px'
          }}
        >
          <Text textStyle="supplementProductCardTitleJP">
            {productData.titleJP}
          </Text>

          <Text textStyle="supplementProductCardTitleEN" mt={1}>
            {productData.titleEN}
          </Text>

          <Text
            textStyle="supplementProductCardSubTitle"
            bg="#9cb25a"
            w={{
              base: 'auto',
              md: 'max-content'
            }}
            mt={5}
            color="white"
            px={2}
            py={1}
          >
            {productData.subTitle}
          </Text>

          <Text textStyle="supplementProductCardDescJP" mt={5}>
            {productData.descJP}
          </Text>

          <Text textStyle="supplementProductCardDescEN" mt={5}>
            {productData.descEN}
          </Text>
        </Box>

        {/* Benifits */}
        <Box w="100%" mt={5}>
          <AspectRatio
            ratio={400 / 59}
            w="100%"
            display={{
              base: 'none',
              md: 'block'
            }}
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/be-6-1731641944041.png'
              }
              alt="traditional item"
              fill
            />
          </AspectRatio>
          <Box
            display={{
              base: 'block',
              md: 'none'
            }}
          >
            <BenefitMobile items={benefitData} isOne />
          </Box>
        </Box>

        {/* Buy Button */}
        <HStack
          justifyContent={{
            base: 'flex-start',
            md: 'flex-start'
          }}
          alignItems="center"
          gap={4}
          mt={5}
        >
          <Link href="https://habbit.sg/products/health-plus-kampo-brain-and-memory-vitalizer-90s">
            <AspectRatio
              ratio={1537 / 864}
              w={{
                base: '120px',
                sm: '120px',
                md: '140px',
                lg: '160px',
                xl: '160px'
              }}
              _hover={{
                opacity: 0.7
              }}
              mt={3}
            >
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/buy-now-btn-1714038035225.png'
                }
                alt="buy now btn"
                fill
              />
            </AspectRatio>
          </Link>

          <Box
            w={{
              base: '244px',
              xl: '244px'
            }}
            mt={2}
          >
            <AspectRatio ratio={123 / 36} w="100%">
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item1-certificate-1730969831994.png'
                }
                alt="traditional item"
                fill
              />
            </AspectRatio>
          </Box>
        </HStack>
      </Box>

      <Box
        w={{
          base: '100%',
          lg: '50%'
        }}
        ml={{
          base: '0'
        }}
      >
        <AspectRatio ratio={1361 / 1494} w="100%">
          <Image src={productData.imageUrl} alt={productData.titleEN} fill />
        </AspectRatio>
      </Box>
    </Flex>
  )
}

export default ProductCard06
